import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { AppService } from 'src/_services/app.service';
import { AuthenticationService } from 'src/_services/authentication.service';

@Component({
  selector: 'app-premium-mapping',
  templateUrl: './premium-mapping.component.html',
  styleUrls: ['./premium-mapping.component.scss']
})
export class PremiumMappingComponent implements OnInit {
  betFairEventId = "";
  srEventId = "";
  unmapBetFairEventId = "";

  constructor(
    public dialog: MatDialog,
    private appService: AppService,
  ) { }

  ngOnInit() {
  }

  bfEventIdSelection(value) {
    this.betFairEventId = (value || "").trim();
  }

  bfEventIdSelectionClear() {
    this.betFairEventId = "";
  }

  srEventIdSelection(value) {
    this.srEventId = (value || "").trim();
  }

  srEventIdSelectionClear() {
    this.srEventId = "";
  }

  unmapBfEventIdSelection(value) {
    this.unmapBetFairEventId = (value || "").trim();
  }

  unmapBfEventIdSelectionClear() {
    this.unmapBetFairEventId = "";
  }

  onMapping() {
    let dialogRef = this.dialog.open(PremiumModalComponent, {
    backdropClass: "backdropBackground",
    hasBackdrop: true,
    data: {
      bEventId : this.betFairEventId,
      sEventId : this.srEventId
    }
  });

  dialogRef.afterClosed().subscribe((result) => {
    if (result == true) {
      this.srEventIdSelectionClear()
      this.bfEventIdSelectionClear()
    }
  });
}

  onUnmap() {
    const bEventId = (this.unmapBetFairEventId || "").trim();
    if (!bEventId) return;

    const dialogRef = this.dialog.open(PremiumUnmapModalComponent, {
      backdropClass: "backdropBackground",
      hasBackdrop: true,
      data: { bEventId },
    });

    dialogRef.afterClosed().subscribe((confirmed) => {
      if (confirmed === true) {
        this.unmapConfirmed(bEventId);
      }
    });
  }

  private unmapConfirmed(bEventId: string) {
    const payload = { bEventId };
    try {
      this.appService.unMapEvent(payload).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.appService.openSuccessBar("Unmapped");
          this.unmapBfEventIdSelectionClear();
        } else {
          this.appService.openErrorBar(res.errorDescription);
        }
      });
    } catch (err) { }
  }

}

@Component({
  selector: "dialog-data-example-dialog",
  templateUrl: "./premium_modal.component.html",
  styleUrls: ["./premium-mapping.component.scss"],
})
export class PremiumModalComponent {

  constructor(
    public dialogRef: MatDialogRef<PremiumModalComponent>,
    private appService: AppService,
    private authenticationService: AuthenticationService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
  }

  ngOnInit() {
  }

  onSubmit() {
    let filters = {
      bEId : this.data.bEventId,
      sEId : this.data.sEventId
    }
    this.appService.mapPremium(filters).subscribe((res) => {
      if (res.status == "RS_OK") {
        this.dialogRef.close(true);
        this.authenticationService.openSnackBar(res.errorDescription);
      } else {
        this.dialogRef.close();
        this.authenticationService.openErrorSnackBar(res.errorDescription);
      }
      
    });
  }
}

@Component({
  selector: "premium-unmap-modal",
  templateUrl: "./premium_unmap_modal.component.html",
  styleUrls: ["./premium-mapping.component.scss"],
})
export class PremiumUnmapModalComponent {
  constructor(
    public dialogRef: MatDialogRef<PremiumUnmapModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  confirmUnmap() {
    this.dialogRef.close(true);
  }
}